import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthCtx";

const AccountCard = ({ className }) => {
  const authCtx = useAuth();
  return (
    <div
      className={
        "ctWAuto cH100 dFlex dDirRow jS aC accountCard" +
        (className ? ` ${className}` : "")
      }
    >
      <span className="imgContainer">
        <img src={authCtx.user["picture"]} />
      </span>
      <span className="nameContainer">{authCtx.user["name"]}</span>
    </div>
  );
};

const SubsectionItem = ({ text, to, active }) => {
  return (
    <Link to={to} className={"item" + (active ? " active" : "")}>
      <span>{text}</span>
    </Link>
  );
};

export function AppNavigation() {
  const authCtx = useAuth();

  const handleLogoutClick = (e) => {
    let s = window.confirm("Do you really want to logout?");
    if (s) {
      authCtx.logout(true);
    }
  };

  return (
    <>
      <div className="sidebar">
        <div className="inner">
          <div className="section">
            <div className="sub-section">
              <div className="item header-item">
                <img src="/favicon/apple-touch-icon.png" />
              </div>
              <div className="item header-item-active-product">
                <span>guruji</span>
                <span>by helpx.io</span>
              </div>
            </div>
            <div className="seprator"></div>
            <div className="sub-section">
              <SubsectionItem text={"playground"} active={true} />
              <SubsectionItem text={"keys"} />
              <SubsectionItem text={"usage"} />
              <SubsectionItem text={"history"} />
            </div>
            <div className="seprator"></div>
            <div className="sub-section">
              <SubsectionItem text={"account"} />
            </div>
            <div className="seprator"></div>
            <div className="sub-section">
              <SubsectionItem text={"docs"} />
            </div>
          </div>
          <div className="section" style={{ marginBottom: 20 }}>
            <div className="sub-section">
              <div onClick={handleLogoutClick} className={"item"}>
                <span>logout</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
